import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const HowItWorks = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 65%", "end 70%"] });
  const lineHeight = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section id="how" data-testid="how" className="relative bg-[#FAFAF7] py-24 md:py-36">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16 md:mb-24">
          <Reveal>
            <p className="text-sm tracking-luxe uppercase text-[#A39B8E] mb-6">{t.how.kicker}</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              {t.how.title}
            </h2>
          </Reveal>
        </div>

        <div ref={ref} className="relative pl-10 md:pl-0">
          {/* Timeline line */}
          <div className="absolute left-[7px] md:left-1/2 md:-translate-x-1/2 top-2 bottom-2 w-px bg-black/10">
            <motion.div style={{ height: lineHeight }} className="w-full bg-[#8B7355] origin-top" />
          </div>

          <div className="space-y-14 md:space-y-24">
            {t.how.steps.map((s, i) => {
              const left = i % 2 === 0;
              return (
                <div key={i} className="relative md:grid md:grid-cols-2 md:gap-16 items-center">
                  {/* Dot */}
                  <span className="absolute -left-[36px] md:left-1/2 md:-translate-x-1/2 top-1 md:top-1/2 md:-translate-y-1/2 z-10">
                    <span className="block h-4 w-4 rounded-full border border-[#8B7355] bg-[#FAFAF7]" />
                  </span>

                  <Reveal
                    className={left ? "md:text-right md:pr-4" : "md:col-start-2 md:pl-4"}
                    y={30}
                  >
                    <span className="font-display text-5xl md:text-6xl text-[#E4DCD0]">{s.n}</span>
                    <h3 className="mt-2 text-xl md:text-2xl font-display font-light text-[#1A1A1A]">{s.title}</h3>
                    <p className="mt-2 text-sm text-[#1A1A1A]/60 leading-relaxed max-w-sm md:inline-block">
                      {s.text}
                    </p>
                  </Reveal>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
